const opisy = [];

const opisZdjecia =
"\
Hello! I am an ambitious Applied \
Computer Science student seeking opportunities for \
growth in the fascinating world of technology. \
I continuously expand my knowledge and excel in various technologies. \
I enthusiastically design and develop practical \
solutions that bring value to users. My experience includes mobile application development,\
web development, and software development.\
";

const opisProjekt = "\
I believe that the approach to project development is crucial. \
Every project must stem from a genuine desire to achieve its \
intended goal; without it, everything can easily go awry. I always \
ensure that what I do is driven by pure passion and aims to solve the given problems.\
";

const opisTech = '\
As a computer science student, I have a deep appreciation for \
technology and the constant advancements in the field. I am \
fascinated by the rapid pace of innovation that shapes our future. \
With passion, I explore new technologies and their potential, \
seeing them not just as tools but as drivers of social and business change. \
As Steve Jobs once said, "Technology is just a tool. \
In terms of getting the kids working together and motivating them, \
the teacher is the most important." I strive to create solutions \
that transform reality and bring value to individuals and organizations.\
';

const opisNauka = " \
In web development, continuous learning is crucial. With passion,  \
I stay up-to-date with the latest trends and technologies to create  \
innovative and standards-compliant solutions. I am constantly learning because  \
it is the only way to ensure optimal user experience and meet the growing demands of the market. \
";

opisy.push(opisZdjecia);
opisy.push(opisProjekt);
opisy.push(opisTech);
opisy.push(opisNauka);

export { opisy };